const openDB = (dbName, storeName, version = 1) => {
    return new Promise((resolve, reject) => {
        const request = indexedDB.open(dbName, version);

        request.onerror = () => reject('IndexedDB error');
        request.onsuccess = () => resolve(request.result);

        request.onupgradeneeded = (event) => {
            const db = event.target.result;
            if (!db.objectStoreNames.contains(storeName)) {
                db.createObjectStore(storeName);
            }
        };
    });
};

export const saveBlobToIndexedDB = async ({ dbName, storeName, version = 1, key, blob }) => {
    const db = await openDB(dbName, storeName, version);
    const tx = db.transaction(storeName, 'readwrite');
    const store = tx.objectStore(storeName);
    store.put(blob, key);
    return tx.complete;
};

export const getBlobFromIndexedDB = async ({ dbName, storeName, version = 1, key }) => {
    const db = await openDB(dbName, storeName, version);
    const tx = db.transaction(storeName, 'readonly');
    const store = tx.objectStore(storeName);
    return new Promise((resolve, reject) => {
        const request = store.get(key);
        request.onsuccess = () => resolve(request.result || null);
        request.onerror = () => reject('Failed to get blob');
    });
};

export const deleteKeysFromIndexedDB = async ({ dbName, storeName, version = 1, keys = [] }) => {
    if (!Array.isArray(keys) || keys.length === 0) return;

    const db = await openDB(dbName, storeName, version);
    const tx = db.transaction(storeName, 'readwrite');
    const store = tx.objectStore(storeName);

    for (const key of keys) {
        store.delete(key);
    }

    await tx.done?.catch(() => null);
};
